export default __webpack_public_path__ + "static/media/490.ae232ddf.jpg";